import Amplify from 'aws-amplify';
import { Hub } from '@aws-amplify/core';
import { CognitoAuth } from 'amazon-cognito-auth-js';
import { CookieStorage } from 'amazon-cognito-identity-js';


const getCookieConfig = (cognito) => {
  return {
    domain: cognito.COOKIE_STORAGE_DOMAIN,
    path: '/',   // OPTIONAL - Cookie path
    expires: 7,  // OPTIONAL - Cookie expiration in days
    secure: true // OPTIONAL - Cookie secure flag
  };
};

const amplify = ({ env, cognito }) => {
  const amplifyConfigure = {
    Auth: {
      identityPoolId: cognito.IDENTITY_POOL,
      region: cognito.REGION,
      userPoolId: cognito.USER_POOL,
      userPoolWebClientId: cognito.USER_POOL_CLIENT_ID,
    }
  };
  if (env === 'production') amplifyConfigure.Auth.cookieStorage = getCookieConfig(cognito);
  Amplify.configure(amplifyConfigure);
};

const loadFacebookSdk = ({ cognito }) => {
  if (!cognito.FACEBOOK_APP_ID) return;
  window.fbAsyncInit = function () {
    const fb = window.FB;
    fb.init({
      appId: cognito.FACEBOOK_APP_ID,
      cookie: true,
      xfbml: true,
      version: 'v2.11'
    });
  };
  const script = document.createElement('script');
  script.src = 'https://connect.facebook.net/en_US/sdk.js';
  script.async = true;
  script.onload = function () { };
  document.body.appendChild(script);

};

const cognitoAuthHelper = ({ env, cognito, sites }) => {
  let storage = null;
  if (env === 'production') storage = new CookieStorage(getCookieConfig(cognito));
  const authData = {
    ClientId: cognito.USER_POOL_CLIENT_ID,
    UserPoolId: cognito.USER_POOL,
    AppWebDomain: cognito.AMAZON_COGNITO_DOMAIN,
    TokenScopesArray: ['email', 'phone', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    RedirectUriSignIn: sites.token,
    RedirectUriSignOut: sites.token,
    Storage: storage
  };
  const cognitoAuth = new CognitoAuth(authData);
  cognitoAuth.userhandler = {
    onSuccess: function (result) {
      Hub.dispatch('auth', {
        event: 'returnSession',
        data: result
      });
    },
    onFailure: console.error
  };
  window.cognitoAuth = cognitoAuth;
};

/**
 * Contructor
 */
const config = {};

/**
 * Development configurations
 */
config.development = {
  IDENTITY_POOL: 'us-west-2:48df7b6f-1a8e-4e5e-82d1-5d8dcc9bf7af',
  REGION: 'us-west-2',
  USER_POOL: 'us-west-2_JvLPOom6s',
  USER_POOL_CLIENT_ID: '8vqd4dsncqcj7gsmckmk0f2vb',
  AMAZON_COGNITO_DOMAIN: 'kambria-dev.auth.us-west-2.amazoncognito.com',
  FACEBOOK_APP_ID: '1056737837845730',
  GOOGLE_CLIENT_ID: '458983910080-kgbaph6rla2kfe9jhpvliaurts2d67p9.apps.googleusercontent.com',
  COOKIE_STORAGE_DOMAIN: 'kambria.io',
  init: (config) => {
    amplify(config);
    loadFacebookSdk(config);
    cognitoAuthHelper(config);
  }
}

/**
 * Staging configurations
 */
config.staging = {
  IDENTITY_POOL: 'us-west-2:48df7b6f-1a8e-4e5e-82d1-5d8dcc9bf7af',
  REGION: 'us-west-2',
  USER_POOL: 'us-west-2_JvLPOom6s',
  USER_POOL_CLIENT_ID: '8vqd4dsncqcj7gsmckmk0f2vb',
  AMAZON_COGNITO_DOMAIN: 'kambria-dev.auth.us-west-2.amazoncognito.com',
  FACEBOOK_APP_ID: '1056737837845730',
  GOOGLE_CLIENT_ID: '458983910080-kgbaph6rla2kfe9jhpvliaurts2d67p9.apps.googleusercontent.com',
  COOKIE_STORAGE_DOMAIN: 'kambria.io',
  init: (config) => {
    amplify(config);
    loadFacebookSdk(config);
    cognitoAuthHelper(config);
  }
}

/**
 * Production configurations
 */
config.production = {
  IDENTITY_POOL: 'us-west-2:bb49991a-dac8-4cfc-8781-cfeee22f81e6',
  REGION: 'us-west-2',
  USER_POOL: 'us-west-2_45T9iCzrv',
  USER_POOL_CLIENT_ID: '521bkpo7mbeq59l70fkh9rgeqq',
  AMAZON_COGNITO_DOMAIN: 'kambria.auth.us-west-2.amazoncognito.com',
  FACEBOOK_APP_ID: '977019282642152',
  GOOGLE_CLIENT_ID: '458983910080-kgbaph6rla2kfe9jhpvliaurts2d67p9.apps.googleusercontent.com',
  COOKIE_STORAGE_DOMAIN: 'kambria.io',
  init: (config) => {
    amplify(config);
    loadFacebookSdk(config);
    cognitoAuthHelper(config);
  }
}

/**
 * Module exports
 */
export default config;